import { createFileRoute } from "@tanstack/react-router";
import { BlogPostView } from "@/components/blog/BlogPostView";
import { getBlogPost } from "@/content/blog";
import { pageMeta, ldScripts, blogPostingLd, breadcrumbLd } from "@/lib/seo";

export const Route = createFileRoute("/dallas-seo-case-study")({
  head: () => {
    const post = getBlogPost("dallas-seo-case-study");
    if (!post) return { meta: [{ title: "Post Not Found" }] };
    
    const path = "/dallas-seo-case-study";
    const base = pageMeta({
      path,
      title: post.title,
      description: post.dek,
      type: "article",
      image: post.heroImage.src,
      keywords: post.tags,
    });

    return {
      ...base,
      scripts: ldScripts(
        blogPostingLd({
          headline: post.title,
          description: post.dek,
          path,
          datePublished: post.publishedISO,
          image: post.heroImage.src,
          authorName: "M. Umair Mansha",
        }),
        breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Blog", path: "/blog" },
          { name: post.title, path },
        ])
      ),
    };
  },
  component: () => {
    const post = getBlogPost("dallas-seo-case-study");
    if (!post) return <div>Post not found</div>;
    return <BlogPostView post={post} />;
  },
});
